import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '../../../../redux/store';
import { NUM_TOTAL_COMMUNITY_CARDS } from '../../../../types/cardTypes';
import { CardDisplay } from '../cardDisplay';
export const RabbitCommunityCardDisplay = ({ rabbitIndex, cardRenderProperties }) => {
    const rabbitRankChar = useAppSelector((state) => state.poker.rabbits[rabbitIndex]?.card.rankChar);
    const rabbitSuitChar = useAppSelector((state) => state.poker.rabbits[rabbitIndex]?.card.suitChar);
    // the index relative to the 5 total community cards (if the first rabbit is the turn, this index is 3)
    const rabbitCommunityCardIndex = useAppSelector((state) => state.poker.rabbits[rabbitIndex]?.index);
    const isFourColorDeckEnabled = useAppSelector((state) => state.selfData.isFourColorDeckEnabled);
    if (!rabbitRankChar || !rabbitSuitChar || rabbitCommunityCardIndex === undefined) {
        return null;
    }
    return (_jsx(CardDisplay, { pixiDataType: 'rabbit', cardRankChar: rabbitRankChar, cardSuitChar: rabbitSuitChar, cardIndex: rabbitCommunityCardIndex, cardEmphasis: 'normal', cardRenderProperties: cardRenderProperties, numCardsInGroup: NUM_TOTAL_COMMUNITY_CARDS, isFourColorDeck: isFourColorDeckEnabled }));
};
